@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-249_782_457)
internal val Res.font.smileysans_oblique: FontResource by lazy {
      FontResource("font:smileysans_oblique", setOf(
        ResourceItem(setOf(), "${MD}font/smileysans_oblique.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("smileysans_oblique", Res.font.smileysans_oblique)
}
